module.exports = __webpack_public_path__ + "img/cuff elastic length.e8bf7c7a.png";